import { jsBridgeEventsLib } from '../js-bridge';
import {
  amplitudeEventsLib,
  type PriceChangeParams,
} from '../amplitude-events';
import { bloomreachEventsLib } from '../bloomreach-events';
import type { PayButtonClickParams } from './types';

export const paymentPageOpen = (source: string | null) => {
  jsBridgeEventsLib.paymentPageOpened({ sourceScreen: source });
};

export const payButtonClick = (params: PayButtonClickParams) => {
  amplitudeEventsLib.paymentClick(
    params.promocodeNumber,
    params.isCharter,
    undefined,
    {
      payment_method: params.paymentMethod ?? 'card',
      installment_term: params.installmentTerm ?? undefined,
    },
  );
  jsBridgeEventsLib.payButtonClicked(params);
  bloomreachEventsLib.payButtonClick(params);
};

export const priceChangeShown = (params: PriceChangeParams) =>
  amplitudeEventsLib.priceChangeShown(params);

export const priceChangeClosed = (params: PriceChangeParams) =>
  amplitudeEventsLib.priceChangeClosed(params);
